<template>
  <v-container fluid>
    <v-row v-if="convocatorias && convocatorias.length > 0">
      <v-col cols="12" v-for="convocatoria in convocatorias" :key="convocatoria.idConvocatoria">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              :value="convocatoria.fechaRegistro"
              rounded
              readonly
              filled
              dense
              background-color="primary"
              color="secondary"
              label="Fecha de registro"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="convocatoria.convocatoria?.fechaHoraPublicacionConvocatoria"
              rounded
              readonly
              filled
              dense
              background-color="primary"
              color="secondary"
              label="Fecha de publicación"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="convocatoria.convocatoria?.plazasVacantes"
              rounded
              readonly
              filled
              dense
              background-color="primary"
              color="secondary"
              label="Plazas vacantes"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="convocatoria.convocatoria?.lugarRecepcionDocumentos"
              rounded
              readonly
              filled
              dense
              background-color="primary"
              color="secondary"
              label="Lugar de recepción"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="my-2">
          <v-col cols="12" md="6">
            <v-card :color="convocatoria.aceptado ? 'success' : 'error'" dark class="pa-3">
              <div class="d-flex align-center">
                <v-icon large class="mr-3">
                  {{ convocatoria.aceptado ? 'mdi-check-circle' : 'mdi-close-circle' }}
                </v-icon>
                <div>
                  <div class="text-subtitle-2">Estado de aceptación</div>
                  <div class="text-h6 font-weight-bold">
                    {{ convocatoria.aceptado ? 'Aceptado' : 'No aceptado' }}
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card :color="convocatoria.promocionado ? 'success' : 'error'" dark class="pa-3">
              <div class="d-flex align-center">
                <v-icon large class="mr-3">
                  {{ convocatoria.promocionado ? 'mdi-check-circle' : 'mdi-close-circle' }}
                </v-icon>
                <div>
                  <div class="text-subtitle-2">Estado de promoción</div>
                  <div class="text-h6 font-weight-bold">
                    {{ convocatoria.promocionado ? 'Promocionado' : 'No promocionado' }}
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-textarea
              label="Convocatoria dirigida a"
              :value="convocatoria.convocatoria?.catDirigido?.title"
              rounded
              filled
              dense
              color="secondary"
              background-color="primary"
              readonly
              auto-grow
              rows="2"
            ></v-textarea>
          </v-col>
          <v-col cols="6">
            <v-textarea
              label="Documentación solicitada"
              :value="convocatoria.convocatoria?.documentacion"
              rounded
              filled
              dense
              color="secondary"
              background-color="primary"
              readonly
              auto-grow
              rows="3"
            ></v-textarea>
          </v-col>
          <v-col cols="6">
            <v-textarea
              label="Requisitos"
              :value="convocatoria.convocatoria?.requisitos"
              rounded
              filled
              dense
              color="secondary"
              background-color="primary"
              readonly
              auto-grow
              rows="3"
            ></v-textarea>
          </v-col>
          <v-col cols="6">
            <v-textarea
              label="Beneficios"
              :value="convocatoria.convocatoria?.beneficios"
              rounded
              filled
              dense
              color="secondary"
              background-color="primary"
              readonly
              auto-grow
              rows="3"
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <v-textarea
              label="Procedimiento de selección"
              :value="convocatoria.convocatoria?.procedimientoSeleccion"
              rounded
              filled
              dense
              color="secondary"
              background-color="primary"
              readonly
              auto-grow
              rows="3"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="12" align="center">
        <v-icon size="64" color="secondary">mdi-alert-circle-outline</v-icon>
        <div class="text-h6 mt-2">No se encontró información de la convocatoria</div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'VerDetalleConvocatoriaDialogComponent',
  props: {
    convocatorias: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
}
</script>
